import { AuthErrorStrings } from '@aws-amplify/auth';

// import { AuthStrings } from '@aws-amplify/ui-components/dist/types/common/Translations';
// import { Translations } from '@aws-amplify/ui-components';

const vocabularies = {
  ja: {
    'Sign In': 'ログイン',
    'Sign in': 'ログイン',
    'Sign Up': 'ユーザーを登録する',
    'Sign Out': 'ログアウト',
    'Sign in to your account': 'ログイン',
    'Username *': 'メールアドレス *',
    'Password *': 'パスワード *',
    'Enter your username': 'メールアドレスを入力',
    'Enter your password': 'パスワードを入力',
    'No account?': 'ユーザーが未登録ですか？',
    'Forgot your password?': 'パスワードをお忘れですか？',
    'Reset password': 'パスワードをリセット',
    'User does not exist': 'ユーザーが存在しません',
    'User already exists': 'ユーザーは既に存在します',
    'Incorrect username or password.':
      'メールアドレスまたはパスワードが違います',
    'Invalid password format': 'パスワードのフォーマットが不正です',
    'Create account': 'ユーザーを登録する',
    'Forgot Password': 'パスワードを忘れた',
    'Change Password': 'パスワードを変更',
    'New Password': '新しいパスワード',
    Email: 'Email',
    // 電話番号の認証を行う際にこちらを表示したい。本当は根本的に直したほうがいい
    'Email Address *': 'ユーザー名',
    'Phone Number': '電話番号',
    'Confirm a Code': 'コードを確認',
    'Confirm Sign In': 'ログインを確認',
    'Confirm Sign up': 'サインアップを確認',
    'Back to Sign In': 'ログインに戻る',
    'Send Code': 'コードを送信',
    Confirm: '確認',
    'Resend Code': 'コードを再送',
    Submit: '送信',
    Skip: 'スキップ',
    Verify: '検証',
    'Verify Contact': '連絡先を検証',
    Code: 'コード',
    'Confirmation Code': '確認コード',
    'Lost your code?': 'コードがありませんか？',
    'Account recovery requires verified contact information':
      'Account recovery requires verified contact information',
    'Invalid phone number format':
      '不正な電話番号フォーマットです。 電話番号は次のフォーマットで入力してください: +12345678900',
    'Create Account': 'ユーザーを登録する',
    'Have an account?': 'ユーザー登録済みですか？',
    'Create a new account': 'ユーザーを登録する',
    'Reset your password': 'パスワードをリセット',
    'An account with the given email already exists.':
      'そのメールアドレスは既に存在します',
    'Password attempts exceeded': 'パスワード試行回数が超過しました',
    [AuthErrorStrings.DEFAULT_MSG]: '認証エラー',
    [AuthErrorStrings.EMPTY_USERNAME]: 'メールアドレスは必須です',
    [AuthErrorStrings.INVALID_USERNAME]:
      'メールアドレスに文字列を使ってください',
    [AuthErrorStrings.EMPTY_PASSWORD]: 'パスワードは必須です',
    [AuthErrorStrings.EMPTY_CODE]: '確認コードは必須です',
    [AuthErrorStrings.SIGN_UP_ERROR]: '登録できませんでした',
    [AuthErrorStrings.NO_MFA]: '有効な2段階認証方法がありませんでした',
    [AuthErrorStrings.INVALID_MFA]: '有効な2段階認証方法ではありませんでした',
    [AuthErrorStrings.EMPTY_CHALLENGE]: 'チャレンジは必須です',
    [AuthErrorStrings.NO_USER_SESSION]: 'セッションがありませんでした',
    'User is not confirmed.': 'メールアドレスを認証してください',
    'Enter your code': '認証コード',
    'Invalid code provided​, please request a code again.':
      '認識コードが間違っています',
    'Password does not conform to policy: Password not long enough':
      'パスワードは8文字以上を入力してください (8文字以上の大文字小文字を含む英数字)',
    'Password does not conform to policy: Password must have uppercase characters':
      'パスワードには大文字を含めてください (8文字以上の大文字小文字を含む英数字)',
    'Password does not conform to policy: Password must have lowercase characters':
      'パスワードには小文字を含めてください (8文字以上の大文字小文字を含む英数字)',
    'Password does not conform to policy: Password must have numeric characters':
      'パスワードには数字を含めてください (8文字以上の大文字小文字を含む英数字)',
    "1 validation error detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6":
      'パスワードは8文字以上、大文字小文字を含む英数字を指定してください',
    "2 validation errors detected: Value at 'password' failed to satisfy constraint: Member must have length greater than or equal to 6; Value at 'password' failed to satisfy constraint: Member must satisfy regular expression pattern: ^[S]+.*[S]+$":
      'パスワードは8文字以上、大文字小文字を含む英数字を指定してください',
    'Invalid phone number format.': '電話番号の形式は間違っています',
  },
};

export default vocabularies;
